import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import wmbLogo from '../../../assets/images/wmb_coalition_logo.png'
import { Typography, Paper, Grid } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: 20,
    padding: 8,
    width: 120
  },
  logo: {
    maxWidth: 90
  },
  text: {
    color: '#0000008a',
    paddingBottom: '0.25rem'
  }
}))

const WeMeanBusiness = () => {
  const classes = useStyles()

  return(
    <Paper elevation={2} className={classes.card}>
      <Grid container direction='column'>
        <Grid container item xs={12} justifyContent='center'>
          <Typography className={classes.text} variant='caption'>Supported by:</Typography>
        </Grid>
        <Grid container item xs={12} justifyContent='center'>
          <img className={classes.logo} src={wmbLogo} alt='WMB Logo'/>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default WeMeanBusiness
